export default __webpack_public_path__ + "static/media/653c79c710af74a6d35328ee4656605d.jpg";